module.exports = __webpack_public_path__ + "static/img/manual-7.40cc63c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-7.png
// module id = Hx5m
// module chunks = 4